import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  override changes = new Subject<void>();

  override itemsPerPageLabel = $localize`Items per page`;
  override nextPageLabel = $localize`Next page`;
  override previousPageLabel = $localize`Previous page`;
  override firstPageLabel = $localize`First page`;
  override lastPageLabel = $localize`Last page`;

  override getRangeLabel: (
    page: number,
    pageSize: number,
    length: number
  ) => string = (page, pageSize, length) => {
    if (length === 0) {
      return $localize`Page 1 of 1`;
    }
    const pageCount = Math.ceil(length / pageSize);
    return $localize`Page ${page + 1} of ${pageCount}`;
  };
}
